import { getFirstRunTimeStamp, setFirstRunTimeStamp } from "@/utils/user/first-run-timestamp";
import { isIOS } from "@/utils/device/is-ios";
import { trialConfig } from "@/configs/trial";

export const getTimeFromStart = () => {
	try {
		// @TODO: cache result in memory + cachedate

		// let freeTrialDaysAfterStart = isIOS() ? 3 : 7;
		// let freeTrialDaysAfterStart = 3;
        // let freeTrialMinutesAfterStart = trialConfig.freeTrialMinutesAfterStart;
		let freeTrialSecondsAfterStart = trialConfig.freeTrialSecondsAfterStart;

		let firstRunTS = getFirstRunTimeStamp();
		setFirstRunTimeStamp(firstRunTS);

		let diff = 0;
		if (localStorage.getItem('extendedTrial')) {
			diff = parseInt(localStorage.getItem('extendedTrial')) - Date.now();
		} else {
			// diff = (parseInt(firstRunTS) + (freeTrialDaysAfterStart * 1000 * 60 * 60 * 24)) - Date.now();
            // diff = (parseInt(firstRunTS) + (freeTrialMinutesAfterStart * 1000 * 60)) - Date.now();
			diff = (parseInt(firstRunTS) + (freeTrialSecondsAfterStart * 1000)) - Date.now();
		}

		return diff;
	} catch (e) {
		window.captureException(e);
		return 0;
	}
}

export const trialDaysLeft = () => {
	return Math.ceil(trialHoursLeft() / 24);
}

export const trialHoursLeft = () => {
	try {
		const diff = getTimeFromStart();
		const dateDiff = Math.ceil(diff / (1000 * 60 * 60));
		return dateDiff > 0 ? dateDiff : 0;
	} catch (e) {
		window.captureException(e);
		return 0;
	}
}

export const trialMinutesLeft = () => {
	try {
		const diff = getTimeFromStart();
		const dateDiff = Math.ceil(diff / (1000 * 60));
		return dateDiff > 0 ? dateDiff : 0;
	} catch (e) {
		window.captureException(e);
		return 0;
	}
}
